export default "__VITE_PUBLIC_ASSET__cbf23c08__"